export default [
  {
    path: '/app/reclutamiento/gestion-fichas',
    name: 'rt-reclutamiento-fichas',
    component: () => import('@/views/palmas/reclutamiento/ficha/Ficha.vue'),
    meta: {
      contentRenderer: 'sidebar-left',
      contentClass: 'email-application',
    },
  },
]
